/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import classNames from 'classnames';
import jump from 'jump.js';
import Img from 'react-image';
import { Link } from '@reach/router';
import { Translation } from 'react-i18next';

import Logo from '../../img/logo.png';
import { history } from '../../utils/router-history';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: 'hidden',
		};
	}

	toggleExpansion = e => {
		const { isExpanded } = this.state;
		e.preventDefault();
		console.log(isExpanded);
		this.setState({
			isExpanded: isExpanded === 'hidden' ? '' : 'hidden',
		});
	};

	navigateTo = section => {
		// debugger;
		console.log({ section });
		if (this.props.page && this.props.page === 'home') {
			jump(`section#${section}`, {
				offset: -90,
				duration: 1000,
			});
		} else {
			this.navigateToHome(section);
		}
	};

	navigateToHome = section => {
		history.navigate('/#' + section, { replace: true });
	};

	render() {
		const { isExpanded } = this.state;
		let headerClass = classNames({
			header: true,
			'fixed bg-white w-full z-30 shadow text-white': true,
		});

		let navMenuClass = classNames({
			'cursor-pointer menu-items text-base inline-block no-underline py-2 px-3 font-extrabold text-ccu-dark-green': true,
		});

		let toggleColourClass = classNames({
			'no-underline hover:no-underline font-bold text-2xl lg:text-4xl': true,
		});

		let navContentClass = classNames({
			'w-full flex-grow lg:flex lg:items-center lg:w-auto lg:block mt-2 lg:mt-0  text-black p-4 lg:p-0 z-20': true,
			[`${isExpanded}`]: true,
		});

		return (
			<nav id='header' className={headerClass}>
				<div className='w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-5'>
					<div className='pl-4 flex items-center'>
						<a
							className={toggleColourClass}
							onClick={() => history.navigate('/')}
						>
							<Img className='logo z-50' src={Logo} alt='Logo' />
						</a>
					</div>

					<div className='block lg:hidden pr-4'>
						<button
							id='nav-toggle'
							className='flex items-center p-1 bg-ccu-dark-green hover:border-ccu-green'
							onClick={this.toggleExpansion}
						>
							<svg
								className='fill-current h-6 w-6'
								viewBox='0 0 20 20'
								xmlns='http://www.w3.org/2000/svg'
							>
								<title>Menu</title>
								<path d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z' />
							</svg>
						</button>
					</div>

					<div className={navContentClass} id='nav-content'>
						<ul className='list-reset lg:flex justify-end flex-1 items-center'>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('nosotros')}
								>
									<Translation>{t => <p>{t('layout.menu.we')}</p>}</Translation>
								</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('principios')}
								>
									<Translation>
										{t => <p>{t('layout.menu.values')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('areas')}
								>
									<Translation>
										{t => <p>{t('layout.menu.areas')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('marcas')}
								>
									<Translation>
										{t => <p>{t('layout.menu.trademarks')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('sustentabilidad')}
								>
									<Translation>
										{t => <p>{t('layout.menu.sutentability')}</p>}
									</Translation>
								</span>
							</li>
							{/* <li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('experiencia')}
								>
									<Translation>
										{t => <p>{t('layout.menu.experience')}</p>}
									</Translation>
								</span>
							</li> */}
							<li className='mr-2 pointer'>
							<a
								id='navAction'
								href='https://postulacionesccuargentina.hiperjob.com/ofertas'
								target='_blank'
								rel='noopener noreferrer'
								className={navMenuClass}
							>
								<Translation>
									{t => <p>{t('layout.menu.opportunities')}</p>}
								</Translation>
							</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}

export default Header;
